import { render, staticRenderFns } from "./opportunities-manage-stages-widget.vue?vue&type=template&id=0502e6c9&"
import script from "./opportunities-manage-stages-widget.vue?vue&type=script&lang=js&"
export * from "./opportunities-manage-stages-widget.vue?vue&type=script&lang=js&"
import style0 from "./opportunities-manage-stages-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports